export default __webpack_public_path__ + "static/media/unoffical_kt.f70d39d3.png";